import { LogoCloudCarousel } from "../../../../modules/content/components/LogoCloudCarousel/LogoCloudCarousel";
import { LogoCloudGrid } from "../../../../modules/content/components/LogoCloudGrid/LogoCloudGrid";
import { VelvetCommonContent } from "../../../../modules/content/components/VelvetCommonContent/VelvetCommonContent";
import { VelvetSection } from "../../../../modules/content/components/VelvetSection/VelvetSection";
import type { ILogoCloudBlockProps } from "./LogoCloudBlock.props";

export const LogoCloudBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  eyebrow,
  heading,
  items,
  parentClass,
  spacing,
  variant,
}: ILogoCloudBlockProps) => {
  if (!items?.length) return null;
  return (
    <VelvetSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="flex flex-col gap-16 md:gap-20">
        <VelvetCommonContent
          alignment={alignment}
          buttons={buttons}
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        {variant === "carousel" ? (
          <LogoCloudCarousel items={items} />
        ) : (
          <LogoCloudGrid items={items} />
        )}
      </div>
    </VelvetSection>
  );
};

LogoCloudBlock.displayName = "Block::LogoCloudBlock";
